import { createEndpointConfig } from '@ricoh/ria.client.core/plugins/swr/common';

import type {
  ChangePasswordRequestData,
  CookieSettings,
  CreatePasswordRequestData,
  ExternalSigninRequestData,
  RequestResetPasswordRequestData,
  RequestSendOTPRequestData,
  SigninRequestData,
  VerifyOTPRequestData,
  VerifyRequestData,
} from './_request.type';

import createRequestConfig from '../_config';

/** Internal request config. */
const requestConfig = createRequestConfig('account', (keyBase) => ({
  signin: createEndpointConfig(`[post] ${keyBase}/account/signin`, (requestData: SigninRequestData) => ({
    method: 'post',
    url: 'account/signin',
    data: {
      ...requestData,
      isRememberLogin: true,
    },
  })),
  signout: createEndpointConfig(`[post] ${keyBase}/account/signout`, () => ({
    method: 'post',
    url: 'account/signout',
  })),

  verifyOTP: createEndpointConfig(`[post] ${keyBase}/account/verify-otp`, (requestData: VerifyOTPRequestData) => ({
    method: 'post',
    url: 'account/verify-otp',
    data: requestData,
  })),
  requestSendOTP: createEndpointConfig(`[post] ${keyBase}/account/send-otp`, (requestData: RequestSendOTPRequestData) => ({
    method: 'post',
    url: 'account/send-otp',
    data: requestData,
  })),

  getAccountInfo: createEndpointConfig(`[get] ${keyBase}/account`, () => ({
    method: 'get',
    url: 'account',
  })),

  changePassword: createEndpointConfig(`[post] ${keyBase}/account/change-password`, (requestData: ChangePasswordRequestData) => ({
    method: 'post',
    url: 'account/change-password',
    data: requestData,
  })),

  verifyInitPassword: createEndpointConfig(`[post] ${keyBase}/account/verify-email`, (requestData: VerifyRequestData) => ({
    method: 'post',
    url: 'account/verify-email',
    data: requestData,
  })),
  initPassword: createEndpointConfig(`[put] ${keyBase}/account/confirm`, (requestData: CreatePasswordRequestData) => ({
    method: 'put',
    url: 'account/confirm',
    data: requestData,
  })),

  requestResetPassword: createEndpointConfig(`[post] ${keyBase}/account/reset-password`, (requestData: RequestResetPasswordRequestData) => ({
    method: 'post',
    url: 'account/reset-password',
    data: requestData,
  })),
  verifyResetPassword: createEndpointConfig(`[post] ${keyBase}/account/verify-request`, (requestData: VerifyRequestData) => ({
    method: 'post',
    url: 'account/verify-request',
    data: requestData,
  })),
  resetPassword: createEndpointConfig(`[put] ${keyBase}/account/reset-password`, (requestData: CreatePasswordRequestData) => ({
    method: 'put',
    url: 'account/reset-password',
    data: requestData,
  })),

  externalSignin: createEndpointConfig(`[post] ${keyBase}/account/external-signin`, (requestData: ExternalSigninRequestData) => ({
    method: 'post',
    url: `account/external-signin`,
    data: requestData,
  })),

  getCookieSettings: createEndpointConfig(`[get] ${keyBase}/account/cookie-settings`, () => ({
    method: 'get',
    url: 'account/cookie-settings',
  })),
  setCookieSettings: createEndpointConfig(`[post] ${keyBase}/account/cookie-settings`, (requestData: CookieSettings) => ({
    method: 'post',
    url: 'account/cookie-settings',
    data: requestData,
  })),
}));

export default requestConfig;
